module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-aanwijzend-voornaamwoord.json
// module id = 1296
// module chunks = 74309790708907